var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFaq(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "url(#pattern0_173_972)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_173_972",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_173_972",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_173_972",
    width: 100,
    height: 100,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAAEGElEQVR4nO2dT4gcRRTGK0GJIoKooBeVgKIgHmQR1tWp76vd2XUPXj1FyEGRSNSTxIAkxIPiMTkJohH0IIlCyCEgiBL/oIYEQVEIBEQhhoiniCgG3ZFie3Fc3anX0z07Vc33g3fL1Ov3fqme2e6uaueEEEIIIYQQQgghhBB12eq9vz+E8ATJ50oIAM8CeDSEcJvrCjMzM1cCeArAjyQHBccnAB50JQPgRgAfZdDMQUuxQnK/c26LK43Z2dmrAZzKoImDtgPAvk1rZAjhbgCPbBQkH7KMA+DQtBvHyc6UByZvY7WRBxL/O75JjRG/BElezqBxgwnGx8UIIbkng4YNJh29Xm97EUIAHJ92s7g5saMIISRPJwq5AOBM7kHyt0Qde4oQEv9NYowDrgCyqENCMqtDQjKrQ0Iyq0NCMqtDQjKrQ0Iyq0NCMqujFCEhhBkAL5B8C8DJ6o+5EyTfILm71+vd0jSHhCQAcEVsNoDvR40/dEX2sxDCfGrcEfkkZCO89/cB+NYg4v/yHV9aWrre1URCNgBAn+Qv48gYinMAbq+ZV0LW473vtXhv5TsA1zkjErKOeJoB8ENLMtZyv+uMSMg6SL7SpoyhsN6GlpA1ANxsuB8x7iw56QxIyBAA9hob/HV8oALAyyQPA7ho+Zz3/g6XQEKGAPCBobH/eUZqbm7uWgDvGWbJLpdAQv5hC8nfE2N8utEDa9WPgUsJKW+6BBIy1FDD7NjpRkDy7cTn33cJJOTfX+hHR0UI4U43ApIvJYR8Oerz1XFISFsAeM1wysu+ji4J+SoxQ46VUEcnhPjVyy2DFn7pSUhTAFyVyl8dQ98wloQ0heSrBhk/xXsrqbEkpCEkn0nJqPK/aBlPQhoA4GEAfxpkXJqfn7/JOKaEjIP3/l4Avxpnx5PWcSVkDBYXF68BcLbGVV7z+kAJGQMAr1tkkPy57gIbCakJSRhlXPbeh7rjS0hN4jo/46nqaTcGElIDAHcZZ8fhBjkkxErc9sIg4/Pl5eVtDXJIiBWS7yRy/NF0layE1CBePk/kONJCDgmxEkJYGrXjhPf+HtcQCcmMLOqQkMzqkJDM6ihFCMnHErvBNd5sTEJq0JUcloOQkAoJqUFXclgOQkIqJKQGXclhOQgJqZCQGnQlR2eEkDw6aje4uIN20xwSkhlZ1CEhmdUhIZnVISGZ1SEhmdUhIZnVISGZ1SEhHRSircbzmyHajD8zIZanCgeFx0ob+zpu2gtd4pODGTRtMKmI79aauIyWX3l0sMMy/oqvAHQlUS1P/mLazeNk4nlXIgsLCzeQ/LBLM4OrMsp7bd4acT14XGgJ4Py0G9ogVuJ3RnGnqQRbAcwCeDz+cIg7wOUe1cvNdvT7/Vun3TwhhBBCCCGEEEIIIdwm8zeeGnxf8U6yYAAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaq);
export default __webpack_public_path__ + "static/media/faq.cdb2968914202c1ad94ef02b1ead5000.svg";
export { ForwardRef as ReactComponent };